import { KeyOf } from '~/types';
import { colors } from './colors';

export const always = {
  basic: colors.whiteAlpha90,
  basic_reverse: colors.blackAlpha90,
  label_white: colors.white,
  label_black: colors.neutral800,
} as const;

export type Always = typeof always;
export type AlwaysKeys = KeyOf<typeof always>;
